/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Col_SeasonInputs */

const en_col_season = /** @type {(inputs: Col_SeasonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Season`)
};

/**
* | output |
* | --- |
* | "Season" |
*
* @param {Col_SeasonInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const col_season = /** @type {((inputs?: Col_SeasonInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Col_SeasonInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_col_season(inputs)
});